import { Clipboard } from '@angular/cdk/clipboard';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { DomSanitizer } from '@angular/platform-browser';

import { CurrencyPipe } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';
import { Subscription, interval } from 'rxjs';

import { AppConstants, PROVIDER_NAME, QR_CODE_COPIED_MESSAGE_TIMEOUT, TimerUnitsType } from '../../../../config/appConstants';
import { MessageType } from '../../../../model/message.model';
import { TimerUnits } from '../../../../model/utility.models';
import { DepositService } from '../../../../service/deposit.service';
import { DepositRedirectService } from '../../../../service/depositRedirect.service';
import { GtmService } from '../../../../service/gtm.service';
import { ResizeService } from '../../../../service/resize.service';
import { UserDataService } from '../../../../service/userDataService';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-wallet-process',
    templateUrl: './wallet-process.component.html',
    imports: [
        QRCodeModule,
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        TranslateModule,
        CurrencyPipe,
        MessageComponent,
        NgClass,
        NgTemplateOutlet,
    ],
})
export class WalletProcessComponent implements OnInit {
    depositSubmitResponse: any;
    paymentMethod: string;
    timerDurationDetails: TimerUnits;
    intervalTimer: Subscription;
    QRcodeImage: any = '';
    showInstructions: boolean = false;
    QRCodeCopiedStatus: { [key: string]: any } = {};
    providerName: string;
    showPixQRCode: boolean = false;
    type: MessageType;
    public get messageType(): typeof MessageType {
        return MessageType;
    }

    constructor(
        private depositRedirect: DepositRedirectService,
        private clipboard: Clipboard,
        private sanitizer: DomSanitizer,
        private gtmService: GtmService,
        private depositService: DepositService,
        public userDataService: UserDataService,
        private resizeService: ResizeService,
    ) {}

    ngOnInit(): void {
        this.initialize();
    }
    initialize() {
        this.depositSubmitResponse = this.depositRedirect.depositSubmitResponse;
        this.paymentMethod = this.depositSubmitResponse?.paymentMethod;
        if (this.paymentMethod == AppConstants.PIX) {
            this.providerName = this.depositSubmitResponse?.configData?.pixProvider;
            if (this.providerName === PROVIDER_NAME.OKTO) {
                this.QRcodeImage = this.depositSubmitResponse?.postData?.textToQRcode;
            } else {
                this.QRcodeImage = this.sanitizer.bypassSecurityTrustResourceUrl(
                    `data:image/png;base64, ${this.depositSubmitResponse?.postData?.base64QRcode}`,
                );
            }
            this.counterDownTimer();
        }
        this.resizeService.resizeCashier();
    }
    showQRCodeCopiedNotification(source: string) {
        if (this.QRCodeCopiedStatus[source]?.curr_interval) {
            clearTimeout(this.QRCodeCopiedStatus[source]?.curr_interval);
        }
        const interval = setTimeout(() => {
            this.QRCodeCopiedStatus[source].isActive = false;
        }, QR_CODE_COPIED_MESSAGE_TIMEOUT);
        this.QRCodeCopiedStatus[source] = {
            isActive: true,
            curr_interval: interval,
        };
    }
    copyContentToClipboard(data: any, source: string) {
        try {
            if (source == 'ICON_CLICKED') {
                this.gtmService.copyQrCodeOrCtaOnPix('copy coupon');
            } else {
                this.gtmService.copyQrCodeOrCtaOnPix('pix cta');
            }
            this.clipboard.copy(data);
            this.showQRCodeCopiedNotification(source);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }
    counterDownTimer() {
        const qrcodeTimerLimit = this.userDataService?.userData?.configParams?.PIX_EXPIRY_TIME_IN_SECONDS || '03-00-00';
        const pixQRTimerInfo = qrcodeTimerLimit?.trim()?.split('-');
        const convertHrsToMilliseconds = (hours: any) => {
            const milliseconds = hours * 60 * 60 * 1000;
            return milliseconds;
        };
        const convertMinsToMilliseconds = (minutes: any) => {
            const minutes_milliseconds = minutes * 60 * 1000;
            return minutes_milliseconds;
        };
        const calculateTime = (timeUnits: any, distance: any) => {
            let time: any;
            switch (timeUnits) {
                case TimerUnitsType.HOURS:
                    time = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    break;
                case TimerUnitsType.MINUTES:
                    time = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    break;
                case TimerUnitsType.SECONDS:
                    time = Math.floor((distance % (1000 * 60)) / 1000);
                    break;
            }
            time = time <= 9 ? '0' + time : time;
            return time;
        };
        // Set the date we are counting down to like  current date and adding 3 hrs 2 secs
        const countDownDate =
            new Date().getTime() +
            convertHrsToMilliseconds(pixQRTimerInfo[0]) +
            convertMinsToMilliseconds(pixQRTimerInfo[1]) +
            pixQRTimerInfo[2] * 1000;
        this.timerDurationDetails = { hours: pixQRTimerInfo[0], minutes: pixQRTimerInfo[1], seconds: pixQRTimerInfo[2] };

        this.intervalTimer = interval(1000).subscribe(() => {
            // Get today's date and time in milliseconds
            const now = new Date().getTime();

            // Find the distance between now and countdown date
            const distance = countDownDate - now;
            this.timerDurationDetails = {
                hours: calculateTime(TimerUnitsType.HOURS, distance),
                minutes: calculateTime(TimerUnitsType.MINUTES, distance),
                seconds: calculateTime(TimerUnitsType.SECONDS, distance),
            };
            // If distance is 0 then stop it
            if (distance <= 0) {
                this.timerDurationDetails = {
                    hours: '00',
                    minutes: '00',
                    seconds: '00',
                };
                this.intervalTimer.unsubscribe();
            }
        });
    }

    expand(type: string, value: boolean) {
        (this as any)[type] = value;
        this.resizeService.resizeCashier();
    }
    goToPixProcess() {
        this.depositService.showPixProcessPage.set(true);
    }
}
